import { IItemId } from './content';

export const ASYNC_TASK_MAX_PRIORITY = 2;

export type IAsyncTask<T> = IItemId & {
  status: number;
  attempts: number;
  error: string;
  priority: number;
  value: T;
};
